// extracted by mini-css-extract-plugin
export var modal = "_mf-0";